"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.building = void 0;
var React = require("react");
var PlaceAvailable_1 = require("@/pages/place/components/PlaceAvailable");
var PlaceDistrict_1 = require("@/pages/place/components/PlaceDistrict");
var PlaceNeighbourhood_1 = require("@/pages/place/components/PlaceNeighbourhood");
var PlaceCards_1 = require("@/pages/place/components/PlaceCards");
var Place_1 = require("@/pages/place/components/Place");
var classNames = require("classnames");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var PlaceFollowButton_1 = require("@/pages/place/components/PlaceFollowButton");
var format_1 = require("@/utils/format");
var PlaceHero_1 = require("@/pages/place/components/PlaceHero");
var DistrictContactAgent_1 = require("@/pages/place/components/DistrictContactAgent");
var aboutToDistrictInfo_1 = require("@/pages/place/transformers/aboutToDistrictInfo");
var PlaceChart_1 = require("@/pages/place/components/PlaceChart");
var PlaceTransaction_1 = require("@/pages/place/components/PlaceTransaction");
var districtPage = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(PlaceDistrict_1.placeDistrict, __assign({}, aboutToDistrictInfo_1.aboutToDistrictInfo(props))),
        React.createElement(DistrictContactAgent_1.DistrictContactAgent, __assign({}, props)),
        React.createElement(PlaceChart_1.default, { hidden: !props.showChart }),
        React.createElement(PlaceTransaction_1.default, { hidden: !props.showTransaction, title: props.name }),
        React.createElement(PlaceNeighbourhood_1.placeNeighbourhood, __assign({}, props)),
        React.createElement(PlaceCards_1.placeCards, __assign({}, props)),
        React.createElement(PlaceAvailable_1.placeAvailable, __assign({}, props))));
};
var compactTopSection = function (props) {
    var containerClassName = classNames([
        'l-container',
        'l-container--lr',
        'l-container--stackable',
        'l-pad-top',
        'l-pad-top--mobile-only2',
        't--darker',
        'u-text-center-mobile',
    ]);
    var forText = props.type === SfilterTypeGroup_1.SfilterType.ALL
        ? props.t.forAll
        : props.type === SfilterTypeGroup_1.SfilterType.BUY
            ? props.t.forSale
            : props.t.forRent;
    var nameFull = props.lang.toLowerCase() === 'en-us'
        ? props.name + " " + (props.name === props.nameAlt ? '' : props.nameAlt)
        : props.nameAlt + " " + (props.name === props.nameAlt ? '' : props.name);
    var renderAddress = function (props) {
        var hasLatLng = props.lat && props.lng ? true : false;
        if (hasLatLng && props.address) {
            return (React.createElement("a", { style: { marginLeft: 0 }, target: "_blank", 
                // tslint:disable-next-line:max-line-length
                href: "https://www.google.com/maps/?q=" + props.lat + "," + props.lng + "&zoom=17", className: "o-link" },
                React.createElement("span", { className: "fa fa-map-marker-alt" }),
                " \u00A0",
                props.address));
        }
        return (React.createElement("span", { style: { marginLeft: 0 }, className: "o-link" }, props.address));
    };
    var fullHeadingText = nameFull + " " + forText;
    var renderAddressBlock = function (props) {
        return props.address ? (React.createElement("div", { className: "l-pad u-mobile-hidden" },
            React.createElement("div", { className: "l-container l-container--ll l-container--stackable" },
                React.createElement("div", { className: "l-container__side l-pad-right" },
                    React.createElement("span", { id: "prop-address", className: "u-upper" }, renderAddress(props))),
                React.createElement("div", { className: "l-container__main" })))) : ('');
    };
    var renderExtraButton = function (props) {
        var searchLocation = format_1.default.print(props.t.searchDistrictProperties, [props.district]);
        return (React.createElement("div", { className: "c-place__extra u-mobile-hidden" },
            React.createElement("a", { href: props.viewSaleLinkOfDistrict, className: "o-btn o-btn--flat" },
                React.createElement("span", { className: "fal fa-search-location" }),
                "\u00A0",
                React.createElement("span", { dangerouslySetInnerHTML: { __html: searchLocation } }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: containerClassName },
            React.createElement("div", { className: "l-container__main" },
                React.createElement("h1", { id: "prop-name", className: "o-h1 u-capfirst o-h1--serif" },
                    React.createElement("span", { style: { fontSize: '1em', display: 'inline-block' } }, props.name),
                    "\u00A0",
                    React.createElement("span", { style: { fontSize: '1em', display: 'inline-block' }, className: "u-wh2p-mobile u-wrap-mobile--nopad" }, props.name === props.nameAlt ? '' : props.nameAlt),
                    React.createElement("span", { id: "prop-tag", className: "o-tag o-tag--thin u-mobile-hidden", style: { margin: '0  10px' } }, forText)),
                renderAddressBlock(props),
                React.createElement("div", { id: "prop-district", className: "l-pad--2 u-sm" },
                    React.createElement("h2", { className: "o-plain" }, fullHeadingText),
                    " -",
                    ' ',
                    props.parentName)),
            React.createElement("div", { className: "u-text-center l-container__side-pad " },
                React.createElement("div", { className: "c-place__cta-group" },
                    React.createElement("div", { className: "c-place__ctas" },
                        React.createElement(PlaceFollowButton_1.placeFollowButton, __assign({}, PlaceAvailable_1.propsToAvailableProps(props, props.type), { followClicked: props.followClicked, unfollowClicked: props.unfollowClicked }))),
                    props.showDistrictLink ? renderExtraButton(props) : null))),
        React.createElement(PlaceHero_1.placeHero, __assign({}, props))));
};
exports.building = Place_1.withPlaceTemplate(districtPage, compactTopSection);
exports.default = exports.building;
